<script>
import { mapActions, mapState } from 'pinia';

import { useUserStore } from '../../../store/useUserStore.js';
import { subscribeToNotification, unsubscribeToNotification } from '../api/users';

export default {
  name: 'CpWelcomeUserDialog',
  components: {
    CpButton: require('../button').default,
    CpDialog: require('../dialog').default,
    CpBoxContent: require('../box-content').default,
    CpBox: require('../box').default,
    CpToast: require('../toast').default,
    CpSliceToggle: require('../inputs/SliceToggle').default,
  },
  directives: {
    margin: require('../directives/margins').margin,
    marginLeft: require('../directives/margins').marginLeft,
    marginRight: require('../directives/margins').marginRight,
  },
  props: {
    handleDialog: Function,
    currentUser: Object,
  },
  data() {
    return {
      loading: false,
      subscriptions: {
        newsletters: true,
      },
      error: null,
      user: this.currentUser,
    };
  },
  methods: {
    async handleSubscriptionToNotification(type) {
      this.loading = true;
      const originalValue = !this.subscriptions[type];
      const newValue = !originalValue;

      this.subscriptions = {
        ...this.subscriptions,
        [type]: newValue,
      };
      originalValue
        ? await unsubscribeToNotification({ type })
        : await subscribeToNotification({ type })
            .then(() => {
              this.loading = false;
            })
            .catch(error => {
              this.loading = false;
              this.subscriptions = {
                ...this.subscriptions,
                [type]: originalValue,
              };
              this.error = error.message;
              console.warn(error);
            });
      this.loading = false;
    },
    closeDialog() {
      this.handleDialog();
      if (this.subscriptions.newsletters) {
        this.handleSubscriptionToNotification('newsletters');
      }
      this.removeIsSignupParam();
    },
    navigateTo(path) {
      this.closeDialog();
      this.handleSidebarMennu(path);
      window.location.href = path;
    },
    handleSidebarMennu(categoryClicked) {
      const category = categoryClicked.slice(1);
      this.$emit('sidebarLinkClicked', category);
    },
    removeIsSignupParam() {
      const url = new URL(window.location.href);
      url.searchParams.delete('isSignup');
      window.history.replaceState({}, '', url);
    },
    ...mapActions(useUserStore, ['getUserProfile']),
  },
  computed: {
    ...mapState(useUserStore, ['isUserLogin', 'userProfileData']),
  },
  async mounted() {
    if (this.isUserLogin && !this.currentUser) {
      await this.getUserProfile();
      this.user = this.userProfileData;
    }
  },
};
</script>
<template>
  <CpDialog>
    <CpBox>
      <CpBoxContent>
        <div class="container">
          <i @click.prevent="closeDialog" class="fal fa-times fa-1-5x black-color close-icon"></i>
          <div class="data-container">
            <h2 class="black-color text-center subheadline1">Welcome to <span class="headline">CROWDBLUE</span></h2>
            <p class="body neutral7-color text-center">Here’s some ways to get started:</p>
            <div class="itemContainer">
              <div @click.prevent="navigateTo('#news')" class="item">
                <i class="fal fa-rss-square fa-1-5x neutral7-color" v-margin-right="1"></i>
                <p class="body1 neutral7-color">Stay Up To Date On The Latest Political News</p>
              </div>
              <div @click.prevent="navigateTo(user.permalink)" class="item">
                <i class="fal fa-user-circle fa-1-5x neutral7-color" v-margin-right="1"></i>
                <p class="body1 neutral7-color">Fill Out Your Profile & Introduce Yourself To The Community</p>
              </div>
              <div @click.prevent="closeDialog" class="item">
                <i class="fal fa-compass fa-1-5x neutral7-color" v-margin-right="1"></i>
                <p class="body1 neutral7-color">Join The Conversation</p>
              </div>
              <div @click.prevent="navigateTo('#campaigns')" class="item">
                <i class="fal fa-podium fa-1-5x neutral7-color" v-margin-right="1"></i>
                <p class="body1 neutral7-color">Join A Campaign</p>
              </div>
            </div>
            <div class="slice">
              <CpSliceToggle v-model="subscriptions['newsletters']" />
              <p class="body1 neutral4-color toggle-text" v-margin-left="0.5">Subscribe to receive CrowdBlue’s Daily News</p>
            </div>
          </div>
        </div>
      </CpBoxContent>
    </CpBox>
  </CpDialog>
</template>
<style scoped>
.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 10px 50px;
  max-width: 35ch;
  border: 1px solid var(--black);
  position: relative;
}

.close-icon {
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
}

.data-container {
  display: flex;
  flex-direction: column;
}

.itemContainer {
  display: flex;
  flex-direction: column;
  padding: 0 30px;
}

.item {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.slice {
  display: flex;
  align-items: center;
  border-top: 1px solid var(--black);
  margin-top: 20px;
  padding-top: 5px;
}

.checkbox-label:has(input:disabled) {
  cursor: default;
}

@media screen and (max-width: 768px) {
  .container {
    padding: 10px;
  }
  .itemContainer {
    padding: 0 10px;
  }
}
@media screen and (max-width: 450px) {
  .toggle-text {
    flex: 3;
  }
}
</style>
